import React, { CSSProperties, PropsWithChildren, useLayoutEffect } from 'react'

import { useModalInstance } from '@context/ModalInstanceContext'

import { useWindowResize } from '@utils/domUtils'

import { BottomSheet } from './BottomSheet/BottomSheet'
import { FullScreen } from './FullScreen/FullScreen'
import { Popup } from './Popup/Popup'

export type ModalSize = 'sm' | 'md' | 'lg' | 'xl'

export interface ModalContainerProps extends PropsWithChildren {
  mode?: 'popup' | 'bottomSheet' | 'fullScreen'
  size?: ModalSize
  background?: CSSProperties['background']
  fullHeight?: boolean
}

export const ModalContainer: React.FC<ModalContainerProps> = (props) => {
  const { mode = 'bottomSheet', children, size, background, fullHeight } = props
  const isMobile = useWindowResize()
  const { setContainerMode } = useModalInstance()

  const resolvedMode = !isMobile || mode === 'popup' ? 'popup' : mode
  const containerProps = { size, children, background, fullHeight }

  useLayoutEffect(() => {
    setContainerMode?.(resolvedMode)
  }, [setContainerMode, resolvedMode])

  const renderContainer = () => {
    switch (resolvedMode) {
      case 'fullScreen':
        return <FullScreen {...containerProps} />
      case 'popup':
        return <Popup {...containerProps} />
      case 'bottomSheet':
      default:
        return <BottomSheet {...containerProps} />
    }
  }

  return renderContainer()
}
